import { useTranslation } from "react-i18next";
import { useAppUpdate } from "../../hooks/useAppUpdate";
import styles from "./UpdateBanner.module.css";

/**
 * "A new version is ready — reload."
 *
 * A banner rather than a toast: a toast is an event that has happened and then
 * stops being true, and it auto-dismisses over the top of any other toast. This
 * is a standing fact about the tab, so it stays until it is acted on or waved
 * off, and it never displaces a save confirmation.
 *
 * `role="status"` and `aria-live="polite"` so a screen reader hears it at the
 * next natural pause instead of interrupting whatever is being read.
 */
export function UpdateBanner() {
  const { t } = useTranslation();
  const { updateReady, dismiss } = useAppUpdate();

  if (!updateReady) return null;

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <span className={styles.text}>{t("update.available")}</span>
      <button type="button" className={styles.reload} onClick={() => window.location.reload()}>
        {t("update.reload")}
      </button>
      <button type="button" className={styles.later} onClick={dismiss}>
        {t("update.later")}
      </button>
    </div>
  );
}
